import type { PRODUCT_STATUS } from 'my-purchases/constants/productStatus'
import type { OrderLine as LegacyOrderLine } from 'my-purchases/types/purchaseCommon'
import type { OrderLine } from 'my-purchases/types/purchaseList'

export const countItemsByStatus = (
	lines: LegacyOrderLine[] | OrderLine[] | undefined,
	status: PRODUCT_STATUS
) =>
	lines?.reduce((acc, product) => acc + (product.status === status ? 1 : 0), 0)

export const hasSomeItemsByStatus = (
	lines: OrderLine[] | undefined,
	status: string
) => !!lines?.some((line) => line?.status === status)
